import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBensImoveis = '/service/contabilidade/planejamento/'

class ItensPlanoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            numero: filtro.numero,
        }

        return this.conex.post(urlBensImoveis + 'itensPlanosAnualContratacao/', JSON.stringify(data))
    }
}

export default ItensPlanoService
